import { Row, Col } from 'reactstrap';
import { PageHeader } from '../../components/PageHeader';
import { DataTable } from '../../components/DataTable';
import { KpiCard } from '../../components/KpiCard';
import { useNetfabricStats } from './useNetfabricStats';

/**
 * Produkt-Statistik Netfabric — Betreiber-Sicht, nur lesend. KPI-Kacheln oben,
 * darunter die Aufschlüsselung der Endpunkte nach kind.
 */
const fmt = new Intl.NumberFormat('de-DE');

export function NexusNetfabricStatsPage() {
  const stats = useNetfabricStats();
  const data = stats.data ?? {};
  const rules = data.rules ?? {};
  const byKind = data.byKind ?? [];

  return (
    <div>
      <PageHeader title="Netfabric" subtitle="Produkt-Statistik — Endpunkte, Policy-Regeln, WireGuard" />

      <Row className="g-3 mb-3">
        <Col xs="6" md="4" lg="2"><KpiCard label="Endpunkte" value={fmt.format(data.endpoints ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Tenants" value={fmt.format(data.tenants ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="Regeln" value={fmt.format(rules.total ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="davon aktiv" value={fmt.format(rules.enabled ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="WG-Netze" value={fmt.format(data.wgNetworks ?? 0)} /></Col>
        <Col xs="6" md="4" lg="2"><KpiCard label="WG-Peers" value={fmt.format(data.wgPeers ?? 0)} /></Col>
      </Row>

      <Row className="g-3">
        <Col xs={12} lg={6}>
          <div className="text-muted small text-uppercase mb-2">Endpunkte nach Kind</div>
          <DataTable
            loading={stats.isLoading}
            error={stats.error}
            empty={!stats.isLoading && byKind.length === 0}
            emptyMessage="Keine Endpunkt-Daten."
            onRetry={() => stats.refetch()}
          >
            <thead>
              <tr>
                <th>Kind</th>
                <th className="text-end">Endpunkte</th>
              </tr>
            </thead>
            <tbody>
              {byKind.map((r) => (
                <tr key={r.kind}>
                  <td className="small">{r.kind}</td>
                  <td className="text-end small">{fmt.format(r.n ?? 0)}</td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </Col>
      </Row>
    </div>
  );
}
